import React, { useState, useEffect } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { postAddRejectedSignature } from "../../services/contract";
import { useSearchParams } from "react-router-dom";

export default function RejectModal({ brandId,ip }) {
  const [searchParams] = useSearchParams();
  const [loadValidationButton, setLoadValidationButton] = useState(false);

  const SAC =
    brandId === "1"
      ? "https://bodytech.com.co/contacto"
      : "atencionalcliente@athleticgym.com.co";
  const web =
    brandId === "1"
    ? "https://bodytech.com.co"
    : "https://athleticgym.com.co";


  
  const addRejectedSignature = async () => {
    const data = {
      rejected_signature:1,
      request_server_rejected_signature: `IP: ${ip}, ${window.navigator.userAgent}`,
      agreement_line_uuid:searchParams.get("u"),
      brand_id:brandId

    }
     try {
        
      setLoadValidationButton(true);
       const response = await postAddRejectedSignature(data);
      
       if(response.data.status === "success") {
          window.location.replace(web);
       }

     } catch (error) {
      
     }
  }

  return (
    <Box>
      <Typography>
        Si no esta de acuerdo con lo anteriormente mencionado, por favor
        comuniquese con nosotros en <a href="{SAC}">{SAC}</a>.
      </Typography>
      <Box display={"flex"} justifyContent={"center"} mt={2}>
        <Button
          variant="contained"
          color="secondary"
          // fullWidth={isMobile}
          onClick={() => addRejectedSignature()}
          disabled={loadValidationButton}
        >
          {
            !loadValidationButton
            ? "Aceptar"
            :<CircularProgress size={30} color="success"/>
          }
        </Button>
      </Box>
    </Box>
  );
}

